import React, { FC, useRef } from 'react';
import idGenerator from 'react-id-generator';
import { RadioFlexInput, RadioFlexWrapper } from './RadioFlexField.style';

type RadioFlexFieldProps = {
  value: string;
  onChange?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  isDisabled?: boolean;
  isChecked?: boolean;
  children?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  error?: string | boolean;
};

export const RadioFlexField: FC<RadioFlexFieldProps> = ({
  value = '',
  isDisabled = false,
  isChecked = false,
  children = null,
  onChange,
  error,
}) => {
  const handleCheck = (e: any) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const id = idGenerator();

  const radioRef = useRef<HTMLInputElement>(null);

  const handleContainerClick = () => {
    radioRef?.current?.click();
  };

  return (
    <RadioFlexWrapper onClick={handleContainerClick}>
      <RadioFlexInput
        id={id}
        aria-checked={isChecked}
        type="radio"
        value={value}
        onChange={handleCheck}
        disabled={isDisabled}
        checked={isChecked}
        error={error}
        ref={radioRef}
      />
      <label htmlFor={id}>{children}</label>
    </RadioFlexWrapper>
  );
};
